import API from "../../api";

export default function AppearanceSettings() {

  const applyTheme = (theme) => {
    let finalTheme = theme;

    if (theme === "system") {
      finalTheme = window.matchMedia("(prefers-color-scheme: dark)").matches
        ? "dark"
        : "light";
    }

    document.documentElement.setAttribute("data-theme", finalTheme);
    localStorage.setItem("civilink_theme", theme);
  };

  const setTheme = async (theme) => {
    // Apply immediately
    applyTheme(theme);

    // Save to backend
    try {
      await API.put("/users/theme", {
        theme
      });
    } catch {
      // Silent fail
    }
  };

  return (
    <section className="settings-card">
      <div className="card-header">
        <h3>Appearance</h3>
        <p>Choose how Civilink looks</p>
      </div>

      <div className="option-row">
        <button onClick={() => setTheme("light")}>
          Light
        </button>

        <button onClick={() => setTheme("dark")}>
          Dark
        </button>

        <button onClick={() => setTheme("system")}>
          System
        </button>
      </div>
    </section>
  );
}